import { NotifyReact, SetPhraseEligible, SetPhrasesTillNextTier } from 'Phaser/EventBus';
import { EventStreamPhaser2 } from 'Phaser/GameObjects/CursorMobile';
import { OSMDEventStream } from 'Phaser/GameObjects/OSMDEventStream';
import Logger from 'Utils/Logger';

enum ChevronState {
  Eligible,
  NextEligible,
  Dormant,
  Losing,
}

export default class ChevronManager {
  private phrasesTilNextTier = 4;
  private chevronState: ChevronState = ChevronState.Dormant;
  private eventStream: EventStreamPhaser2 | OSMDEventStream;
  private firstPhrasePlayed = false;

  constructor(eventStream: EventStreamPhaser2 | OSMDEventStream) {
    this.eventStream = eventStream;
  }

  public reset(): void {
    this.phrasesTilNextTier = 4;
    this.chevronState = ChevronState.Dormant;
    this.firstPhrasePlayed = false;
    Logger.debug('[ChevronManager] reset to initial state');
  }

  public onPhraseFinishPlaying() {
    Logger.debug(
      `[ChevronManager] finishedPlayingPhrase\n
        Chevron State: ${this.chevronState}`,
    );
    this.firstPhrasePlayed = true;
    switch (this.chevronState) {
      case ChevronState.Dormant: {
        const acc = this.eventStream.calcAccuracy();
        if (acc >= 95) {
          this.chevronState = ChevronState.Eligible;
          NotifyReact(SetPhraseEligible(true));
        }
        break;
      }
      case ChevronState.Eligible:
        this.gainChevron();
        break;
      case ChevronState.Losing:
        this.loseChevron();
        break;
      case ChevronState.NextEligible:
        this.chevronState = ChevronState.Eligible;
        break;
    }
  }

  private gainChevron() {
    this.phrasesTilNextTier = Math.max(this.phrasesTilNextTier - 1, 0);
    Logger.debug(
      `[ChevronManager] gained chevron\n
        Phrases till next tier: ${this.phrasesTilNextTier}`,
    );
    NotifyReact(SetPhrasesTillNextTier(this.phrasesTilNextTier));
  }

  private loseChevron() {
    this.phrasesTilNextTier = Math.min(this.phrasesTilNextTier + 1, 4);
    Logger.debug(
      `[ChevronManager] lost chevron\n
        Phrases till next tier: ${this.phrasesTilNextTier}`,
    );
    NotifyReact(SetPhrasesTillNextTier(this.phrasesTilNextTier));
  }

  public onTick() {
    Logger.debug(
      `[ChevronManager] onTick\n
        firstPhrasePlayed: ${this.firstPhrasePlayed}`,
    );
    if (!this.firstPhrasePlayed) return;
    const acc = this.eventStream.calcAccuracy();
    if (acc === undefined) {
      Logger.warn('[ChevronManager] Accuracy undefined!');
      return;
    }
    if (acc < 75 && this.chevronState != ChevronState.Losing) {
      this.chevronState = ChevronState.Losing;
      NotifyReact(SetPhraseEligible(false));
    } else if (acc < 95 && this.chevronState != ChevronState.Dormant) {
      this.chevronState = ChevronState.Dormant;
      NotifyReact(SetPhraseEligible(false));
    } else if (
      this.chevronState != ChevronState.Eligible &&
      this.chevronState != ChevronState.NextEligible
    ) {
      NotifyReact(SetPhraseEligible(true));
      this.chevronState = ChevronState.NextEligible;
    }
  }
}
